var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93164 0.0644531C15.2441 0.0644531 19.6191 4.43945 19.6191 9.75195C19.6191 15.1035 15.2441 19.4395 9.93164 19.4395C4.58008 19.4395 0.244141 15.1035 0.244141 9.75195C0.244141 4.43945 4.58008 0.0644531 9.93164 0.0644531ZM9.93164 4.36133C8.99414 4.36133 8.29102 5.10352 8.29102 6.00195C8.29102 6.93945 8.99414 7.64258 9.93164 7.64258C10.8301 7.64258 11.5723 6.93945 11.5723 6.00195C11.5723 5.10352 10.8301 4.36133 9.93164 4.36133ZM12.1191 14.2832V13.3457C12.1191 13.1113 11.8848 12.877 11.6504 12.877H11.1816V8.9707C11.1816 8.73633 10.9473 8.50195 10.7129 8.50195H8.21289C7.93945 8.50195 7.74414 8.73633 7.74414 8.9707V9.9082C7.74414 10.1816 7.93945 10.377 8.21289 10.377H8.68164V12.877H8.21289C7.93945 12.877 7.74414 13.1113 7.74414 13.3457V14.2832C7.74414 14.5566 7.93945 14.752 8.21289 14.752H11.6504C11.8848 14.752 12.1191 14.5566 12.1191 14.2832Z",
    fill: "#F0823E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.52e002f12907acb70ef47df04d2b35fa.svg";
export { ForwardRef as ReactComponent };